import './FinancialAssistanceSuccess.scss';

import { useEffect } from 'react';
import { Container, Stack } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faMemoCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import PageContainer from '@layouts/container/PageContainer';

const FinancialAssistanceSuccess = () => {
  const location = useLocation();
  const state = location.state as { message?: string };
  const navigate = useNavigate();

  useEffect(() => {
    if (!state?.message) {
      navigate('/access');
    }
  }, [state?.message, navigate]);

  return (
    <PageContainer>
      <Container fluid='xxl' className='financial-assistance-success-container'>
        <Stack direction='vertical' gap={4} className='bg-white rounded-3 financial-assistance-success-content'>
          <h1 className='text-center text-primary fw-medium'>Your application has been submitted for review!</h1>
          <div className='success-body d-flex flex-column align-items-center'>
            <p className='fs-4 fw-medium text-center mb-4 body-title'>What’s Next on Your MyOme Journey?</p>
            <div className='w-100 divider' />
            <FontAwesomeIcon icon={faMemoCircleCheck as IconDefinition} fontSize={40} className='mb-3 text-primary' />
            <p className='text-center text-secondary'>{state?.message}</p>
          </div>
        </Stack>
      </Container>
    </PageContainer>
  );
};

export default FinancialAssistanceSuccess;
